module.exports = __webpack_public_path__ + "static/media/wd_page_area03_img_en.253acd46.png";